/**
 * Forms Widget Table Empty View
 *
 * @package Ninja Forms
 * @subpackage Dashboard
 * @copyright (c) 2017 WP Ninjas
 * @since 3.2
 */
define( 'views/widgets/forms/formsTableEmpty',[], function() {
    var view = Marionette.View.extend( {
        template: "#tmpl-nf-widget-forms-table-empty",
        tagName: 'tr',
    } );
    return view;
} );

